export default __webpack_public_path__ + "static/media/l4-p6.c90e062d.png";